import { CatalogResourceDc, CatalogResourceType, DataSourceType, GeometryType } from "@evergis/api";
import { getFileType } from "./getFileType";
import { FileType } from "./types";

// eslint-disable-next-line max-lines-per-function
export const getResourceType = (item: CatalogResourceDc): FileType => {
  const { type, subtype, geometryType, contentType, name } = item || {};

  if ([CatalogResourceType.Layer, CatalogResourceType.Map, CatalogResourceType.Table].includes(type)) {
    if (type === CatalogResourceType.Map) {
      return FileType.MAP;
    }

    if (type === CatalogResourceType.Layer && ["PostgresTileLayerService"].includes(subtype)) {
      return FileType.RASTER;
    }

    if (type === CatalogResourceType.Layer && ["RemoteTileService"].includes(subtype)) {
      return FileType.XYZ;
    }

    if (type === CatalogResourceType.Layer && ["ProxyService"].includes(subtype)) {
      return FileType.WMS;
    }

    if (type === CatalogResourceType.Table && ["TileCatalogTable"].includes(subtype)) {
      return FileType.RASTER;
    }

    if (type === CatalogResourceType.Layer || type === CatalogResourceType.Table) {
      if (!geometryType) {
        return FileType.TABLE;
      }

      const parsedGeometryType = geometryType.charAt(0).toLowerCase() + geometryType.substring(1);
      const fixedGeometryType = parsedGeometryType === "polygon" ? GeometryType.Polygon : parsedGeometryType;

      switch (fixedGeometryType) {
        case GeometryType.Point:
        case GeometryType.Multipoint:
          return FileType.POINTS;
        case GeometryType.Polyline:
          return FileType.LINES;
        case GeometryType.Polygon:
          return FileType.POLYGON;
        default:
          return FileType.TABLE;
      }
    }
  }

  if (type === CatalogResourceType.DataSource && subtype === DataSourceType.GisServer) {
    return FileType.ArcGISServer;
  }

  if (type === CatalogResourceType.DataSource && subtype === DataSourceType.S3) {
    return FileType.AmazonS3;
  }

  if (type === CatalogResourceType.DataSource) {
    return FileType.PostreSQL;
  }

  if (subtype === "PostgresSchema") {
    return FileType.PostgresSchema;
  }

  if (subtype === "ArcgisMapServer") {
    return FileType.ArcGISMapServer;
  }

  if (subtype === "ArcgisFeatureServer") {
    return FileType.ArcGISFeatureServer;
  }

  return getFileType(contentType, name);
};
